export default __webpack_public_path__ + "static/media/assignment-printouts.ebdb31c4.pdf";